import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../apiCalls/rtkBaseQuery';

export const faqApi = createApi({
    baseQuery,
    reducerPath: 'faqApi',
    tagTypes: ['faq'],
    endpoints: (builder) => ({
        getFaqList: builder.query({
            query: () => ({
                url: '/admin/site/faq',
                method: 'GET',
            }),
            keepUnusedDataFor: 0,
            providesTags: ['faq'],
        }),
        getFaqBySection: builder.query({
            query: (section) => ({
                url: `/admin/site/faq-by-section/${section}`,
                method: 'GET',
            }),
            keepUnusedDataFor: 0,
            providesTags: ['faq'],
        }),
        getFaqById: builder.query({
            query: (id) => ({
                url: `/admin/site/faq/${id}`,
                method: 'GET',
            }),
            keepUnusedDataFor: 0,
            providesTags: ['faq'],
        }),
        createFaq: builder.mutation({
            query: (data) => ({
                url: '/admin/site/faq',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['faq'],
        }),
        updateFaq: builder.mutation({
            query: ({ id, data }) => ({
                url: `/admin/site/faq/${id}`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['faq'],
        }),
        deleteFaq: builder.mutation({
            query: (id) => ({
                url: `/admin/site/delete-faq/${id}`,
                method: 'POST',
            }),
            invalidatesTags: ['faq'],
        }),
    }),
});

export const {
    useCreateFaqMutation,
    useDeleteFaqMutation,
    useGetFaqBySectionQuery,
    useGetFaqListQuery,
    useLazyGetFaqByIdQuery,
    useUpdateFaqMutation,
} = faqApi;
